import { useEffect, useState } from "react"
import { type Theme, ThemeProviderContext } from "@/context/theme/theme-context.ts"

type ThemeProviderProps = {
	children: React.ReactNode
	defaultTheme?: Theme
	storageKey?: string
}

export function ThemeProvider({ children, defaultTheme = "system", storageKey = "vite-ui-theme" }: ThemeProviderProps) {
	const [theme, setTheme] = useState<Theme>(() => (localStorage.getItem(storageKey) as Theme) || defaultTheme)

	useEffect(() => {
		const root = window.document.documentElement
		const resolved =
			theme === "system" ? (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light") : theme
		const other = resolved === "dark" ? "light" : "dark"
		root.classList.remove(other)
		root.classList.add(resolved)
	}, [theme])

	const value = {
		theme,
		setTheme: (theme: Theme) => {
			localStorage.setItem(storageKey, theme)
			setTheme(theme)
		},
	}

	return <ThemeProviderContext.Provider value={value}>{children}</ThemeProviderContext.Provider>
}
